export const API_VERSION_V1 = "/v1";
export const API_VERSION_V2 = "/v2";
export const FORUM = API_VERSION_V1 + "/forum";
export const FEEDBACK = API_VERSION_V1 + "/feedback";
export const ADD = "/add";
export const EMPLOYEE = API_VERSION_V1 + "/employee";
export const EMPLOYEE_V2 = API_VERSION_V2 + "/employee";
export const PROFILE = API_VERSION_V1 + "/profile";
export const PROFILE_DOCUMENT_V2 = API_VERSION_V2 + "/profile/document";
export const PROFILE_VERIFICATION_V2 = API_VERSION_V2 + "/profile/verification";
export const PROFILE_NOTIFICATIONS_V2 = API_VERSION_V2 + "/profile/notifications";
export const BILLS = "/bills";
export const LOGO = "/logo";
export const TRANSPORT = API_VERSION_V1 + "/transport";
export const TRANSPORT_V2 = API_VERSION_V2 + "/transport";
export const DOCUMENT = "/document";
export const SEEN_ENTITIES = API_VERSION_V2 + '/seen-entities';

export const DOCUMENT_STATUS = "/documentStatusesTypes";
export const DOCUMENT_TYPE = "/documentTypes";
export const BILLS_STATUS = "/billsesStatusesTypes";

export const PHOTO = "/photo";
export const MOBILE = "/mobile";

export const UTILS = API_VERSION_V1 + "/utils";

export const BODYWORK = API_VERSION_V1 + "/bodywork";
export const ADR = "/adr";
export const LOADING = API_VERSION_V1 + "/loading";
export const MESSENGER = "/messenger";
export const MESSENGERS = "/messengers";
export const PATRIAL_LOAD = "/partialLoad";
export const PAYMENT = "/payment";
export const ROLES = "/roles";

export const EXCHANGE = "/exchange";
export const LOADING_TYPES = "/loadingTypes";
export const UNLOADING_TYPES = "/unloadingTypes";
export const OUTPUT_BY = "/outputBy";

export const ROUTE_TO = "/routeTo";
export const ROUTE_FROM = "/routeFrom";

export const CARGO = API_VERSION_V1 + "/cargo";
export const CARGO_V2 = API_VERSION_V2 + "/cargo";

export const TRACKPARK = "/trackpark";
export const GET_CONTACS_BY_ID = "/getContactsById";
export const GET_BY_ID = "/getById";

export const TEMPLATE = "/template";

export const EXISTS = "/exists";

export const CARGO_DESIGNATIONS = "/cargoDesignations";
export const PACKAGES = "/packages";
export const TIME_PERIOD = "/timePeriod";

export const TRANSPORT_ADDED = "/transportAdded";
export const TRANSPORT_BURNING_RATES = "/transportBurningRates";
export const TRANSPORT_FUEL = "/transportFuel";
export const TRANSPORT_MANUFACTURERS = "/transportManufacturers";
export const TRANSPORT_VEHICLES = "/transportVehicles";
export const COUNTRIES = "/countries";
export const TRANSPORT_BODY_TYPES = "/transport-bodytypes";
export const TRANSPORT_BODY_TYPES_ADDITIONALS = "/transportBodytypeAdditionals";
export const TRANSPORT_LOADING_TYPES_ADDITIONALS = "/transportLoadingTypesAdditionals";
export const TRANSPORT_MANUFACTURE_YEARS = "/transportManufactureYears";
export const VARIANT_TYPES = "/variantTypes";

export const PAYMENT_RATE_TYPES = "/paymentRateTypes";
export const PAYMENT_TYPES = "/paymentTypes";

export const SECURITY = API_VERSION_V1 + "/security";
export const SECURITY_V2 = API_VERSION_V2 + "/auth";
export const CODE = "/code";
export const GENERATE = "/generate";
export const FORGOT = "/forgot";
export const REFRESH_TOKEN = "/refreshToken";
export const RESTORE = "/restore";

export const CURRENCIES = "/currencies";

export const NEWS = API_VERSION_V2 + "/news";
export const PARTNERS = API_VERSION_V2 + "/partners";
export const USEFUL = API_VERSION_V2 + "/useful";
export const MESSAGES = API_VERSION_V1 + "/messages";
export const AUCTION = API_VERSION_V1 + "/auction";
export const MARKET = API_VERSION_V1 + "/market";
export const TENDER = API_VERSION_V1 + "/tender";
export const CONTACTS = API_VERSION_V1 + "/contacts";
export const CHAT_CONVERSATION = API_VERSION_V1 + "/chat/conversation";

export const AIR = {
    base: API_VERSION_V1 + "/air",
    search: API_VERSION_V1 + "/air/search",
    up: API_VERSION_V1 + "/air/up",
    own: API_VERSION_V1 + "/air/own",
};

export const AUTH = {
    SIGN_IN_URL: API_VERSION_V2 + "/auth/signin",
    SIGN_UP_URL: API_VERSION_V2 + "/auth/signup",
    RESTORE: API_VERSION_V2 + "/auth/restore",
    REFRESH: API_VERSION_V2 + "/auth/refresh",
    LOGOUT: API_VERSION_V2 + "/auth/logout",
};

export const COMPANY = {
    GET: API_VERSION_V1 + "/company/",
    PATCH: API_VERSION_V1 + "/company/",
    PATCH_LOGO: API_VERSION_V1 + "/company/logo/",
    CHECK: API_VERSION_V1 + "/company/check",
};

export const COMPANIES_V2 = API_VERSION_V2 + "/companies";
export const ROLE_CHANGE_REQUEST = "/role-change-request";

export const EMPLOYEE_ENDPOINTS = {
    PASSWORD: API_VERSION_V1 + "/employee/password",
    PHOTO: API_VERSION_V1 + "/employee/photo",
    CODE: API_VERSION_V1 + "/employee/code",
};
